import ButtonLargeMixin from './mixins/button-large-mixin.js';
import ButtonOutlinedMixin from './mixins/button-outlined-mixin.js';
import TpButton from './tp-button.js';

class TpButtonOutlinedLarge extends
  ButtonLargeMixin(
  ButtonOutlinedMixin(
    TpButton
  )) {}

export default TpButtonOutlinedLarge;


